// Copy for the superadmin "Admin Accounts" page. Arabic is Egyptian, like the
// Broadcasts page and the rest of the system's Arabic hints.
const en = {
  title: "Admin Accounts",
  subtitle: "Create an employee account for a company and give it the admin role right away.",
  error: "Error",
  success: "Done",

  sectionAccount: "Account details",
  sectionAccountSub: "What the new admin signs in with",
  sectionExtra: "Extra details",
  sectionExtraSub: "Optional — you can fill these in later from Employee Management",

  name: "Admin name",
  namePlaceholder: "Full name",
  email: "Email",
  emailPlaceholder: "admin@company.com",
  company: "Company",
  companyPlaceholder: "Select company",
  loadingCompanies: "Loading companies…",
  password: "Password",
  passwordPlaceholder: "Enter account password",
  showPassword: "Show password",
  hidePassword: "Hide password",
  infinityCode: "Infinity Code",
  infinityCodePlaceholder: "Leave empty to auto-generate",
  clientCode: "Client Code",
  clientCodePlaceholder: "Leave empty to use the Infinity Code",
  phone: "Phone",
  phonePlaceholder: "e.g. 010xxxxxxx",
  location: "Location",
  locationPlaceholder: "Office / branch",
  optional: "optional",

  passwordNotice: "The password is hashed with bcrypt before it is saved — nobody can read it afterwards.",
  roleNotice: "The account is created as an active employee of the selected company, then promoted to admin.",

  reset: "Clear form",
  create: "Create admin account",
  creating: "Creating admin…",

  nameRequired: "Admin name is required",
  emailRequired: "Email is required",
  companyRequired: "Company is required",
  passwordRequired: "Password is required",
  passwordShort: "Password must be at least 4 characters",
  loadCompaniesFailed: "Failed to load companies",
  createFailed: "Failed to create admin account",
  profileFailed: "Failed to create employee profile",
  codeMissing: "Employee created but Infinity Code is missing",
  promoteFailed: "Employee created but failed to grant admin role",
  created: (email) => `Admin account created for ${email}`,
};

const ar = {
  title: "حسابات الأدمن",
  subtitle: "اعمل حساب موظف لأي شركة وخليه أدمن على طول.",
  error: "حصل خطأ",
  success: "تمام",

  sectionAccount: "بيانات الحساب",
  sectionAccountSub: "البيانات اللي الأدمن الجديد هيدخل بيها",
  sectionExtra: "بيانات إضافية",
  sectionExtraSub: "اختيارية — تقدر تكملها بعدين من إدارة الموظفين",

  name: "اسم الأدمن",
  namePlaceholder: "الاسم بالكامل",
  email: "الإيميل",
  emailPlaceholder: "admin@company.com",
  company: "الشركة",
  companyPlaceholder: "اختار الشركة",
  loadingCompanies: "جاري تحميل الشركات…",
  password: "الباسورد",
  passwordPlaceholder: "اكتب باسورد الحساب",
  showPassword: "إظهار الباسورد",
  hidePassword: "إخفاء الباسورد",
  infinityCode: "كود Infinity",
  infinityCodePlaceholder: "سيبه فاضي وهيتعمل لوحده",
  clientCode: "كود الموظف",
  clientCodePlaceholder: "سيبه فاضي وهياخد كود Infinity",
  phone: "التليفون",
  phonePlaceholder: "مثلًا 010xxxxxxx",
  location: "المكان",
  locationPlaceholder: "المكتب أو الفرع",
  optional: "اختياري",

  passwordNotice: "الباسورد بيتشفّر بـ bcrypt قبل ما يتحفظ — محدش يقدر يقراه بعد كده.",
  roleNotice: "الحساب بيتعمل كموظف شغال في الشركة اللي اخترتها، وبعدين بيتحوّل لأدمن.",

  reset: "مسح البيانات",
  create: "اعمل حساب الأدمن",
  creating: "جاري إنشاء الحساب…",

  nameRequired: "اسم الأدمن مطلوب",
  emailRequired: "الإيميل مطلوب",
  companyRequired: "الشركة مطلوبة",
  passwordRequired: "الباسورد مطلوب",
  passwordShort: "الباسورد لازم يكون 4 حروف على الأقل",
  loadCompaniesFailed: "معرفناش نحمّل الشركات",
  createFailed: "معرفناش نعمل حساب الأدمن",
  profileFailed: "معرفناش نعمل ملف الموظف",
  codeMissing: "الموظف اتعمل بس كود Infinity مش موجود",
  promoteFailed: "الموظف اتعمل بس معرفناش نديله صلاحية الأدمن",
  created: (email) => `حساب الأدمن اتعمل لـ ${email}`,
};

export const text = { en, ar };
export default text;
